import { DateField } from '@/components/shared/date/DateInput';
import { startOfDay } from 'date-fns';
import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import essStrings from '../../ess.translations';

export interface MyLeaveFormValues {
  availabilityType: string;
  start: Date;
  end: Date;
}

export const MyLeaveDateRangeFields: FC = () => {
  const { control, setValue } = useFormContext<MyLeaveFormValues>();
  const start = useWatch({ control, name: 'start' });
  const end = useWatch({ control, name: 'end' });

  return (
    <div className="flex flex-row space-x-5">
      <DateField
        id="start"
        name="start"
        label={essStrings.myLeave.startDate}
        required
        value={start}
        onChange={date => {
          if (date) setValue('start', date);
        }}
        onChangeCallback={(date?: Date) => {
          if (date && startOfDay(date) > startOfDay(end)) {
            setValue('end', date, { shouldDirty: true });
          }
        }}
      />
      <DateField
        id="end"
        name="end"
        label={essStrings.myLeave.endDate}
        required
        value={end}
        onChange={date => {
          if (date) setValue('end', date);
        }}
        onChangeCallback={(date?: Date) => {
          if (date && startOfDay(date) < startOfDay(start)) {
            setValue('start', date, { shouldDirty: true });
          }
        }}
      />
    </div>
  );
};